import enX from "@/locales/en.json";
import deX from "@/locales/de.json";
import frX from "@/locales/fr.json";
import esX from "@/locales/es.json";
import ptX from "@/locales/pt.json";
import ruX from "@/locales/ru.json";
import zhX from "@/locales/zh.json";
import jaX from "@/locales/ja.json";
import arX from "@/locales/ar.json";

export const translations = {
  it: {
    brand: "Aurora-ADV",
    tagline: "ADV · Social · Dati reali · Made in Switzerland",
    heroTitle: "Analizza. Targetizza. Converti.",
    heroTitleA: "Innovativa nel suo genere.",
    heroTitleB: "Unica e irripetibile.",
    heroSubtitle:
      "Analizza gratuitamente il tuo link: ti daremo un Audit & SEO professionale. I nostri tecnici sono a tua disposizione per una consulenza gratuita dopo il report.",
    heroSubtitleLead: "Tutto in una sola soluzione.",
    urlPlaceholder: "https://la-tua-landing.com",
    analyzeBtn: "Analizza landing",
    analyzing: "Analisi in corso...",
    invalidUrl: "URL non valido",
    scores: "Punteggi",
    overall: "Complessivo",
    seo: "SEO",
    speed: "Velocità",
    analytics: "Analytics",
    grade: "Voto",
    metaTags: "Meta Tag",
    title: "Titolo",
    description: "Descrizione",
    canonical: "Canonical",
    viewport: "Viewport",
    robots: "Robots",
    ogTitle: "OG Title",
    checks: "Controlli tecnici",
    passed: "Passato",
    failed: "Fallito",
    critical: "Critico",
    warning: "Attenzione",
    info: "Info",
    aiSuggestions: "Suggerimenti AI",
    impact: "Impatto",
    high: "Alto",
    medium: "Medio",
    low: "Basso",
    trackers: "Tracker installati",
    installed: "installato",
    notFound: "non installato",
    stats: "Statistiche pagina",
    words: "Parole",
    images: "Immagini",
    missingAlt: "senza alt",
    internalLinks: "Link interni",
    externalLinks: "Link esterni",
    loadTime: "Tempo di caricamento",
    pageSize: "Dimensione pagina",
    targetingTitle: "Configura il target",
    targetingSub: "Definisci il pubblico ideale per la tua campagna cross-canale.",
    gender: "Genere",
    all: "Tutti",
    male: "Uomo",
    female: "Donna",
    ageRange: "Fascia di età",
    interests: "Interessi",
    interestsPlaceholder: "Aggiungi interesse e premi Invio",
    geography: "Area geografica",
    geoPlaceholder: "es. Italia, Nord Europa, USA",
    budget: "Budget campagna",
    launchCampaign: "Lancia campagna AI",
    whatsappNumber: "Numero WhatsApp (destinazione lead)",
    whatsappNumberHint: "Formato internazionale, es. +39 351 570 7057",
    whatsappMessage: "Messaggio pre-compilato",
    whatsappMessageDefault: "Ciao, ho visto la vostra pagina e sono interessato",
    whatsappCta: "Pulsante WhatsApp attivo",
    whatsappCtaDesc: "I lead cliccheranno e si apriranno questa chat sul loro telefono.",
    whatsappOpenChat: "Apri chat demo",
    whatsappDetected: "Pulsante WhatsApp rilevato sulla landing",
    whatsappNotFound: "Nessun pulsante WhatsApp sulla landing",
    campaignRunning: "Campagna attiva",
    liveDashboard: "Dashboard live",
    impressions: "Impressioni",
    clicks: "Click",
    conversions: "Conversioni",
    ctr: "CTR",
    cpc: "CPC",
    spent: "Speso",
    of: "di",
    channels: "Canali",
    channel: "Canale",
    performance: "Performance nel tempo",
    liveLeads: "Lead in tempo reale",
    matchScore: "Match",
    action: "Azione",
    impression: "impression",
    click: "click",
    conversion: "conversione",
    newCampaign: "Nuova analisi",
    exportConversions: "Esporta conversioni",
    exportHint: "Scarica tutti i lead convertiti in CSV o Excel",
    budgetOpt: "Ottimizzazione budget real-time",
    budgetOptDesc: "L'AI ridistribuisce automaticamente il budget verso i canali più performanti.",
    autoOptimizing: "Ottimizzazione automatica attiva",
    fetching: "Recupero pagina...",
    parsing: "Parsing HTML...",
    scoring: "Calcolo punteggi...",
    aiRunning: "AI genera suggerimenti...",
    poweredBy: "AI Powered by Claude",
    footer: "Piattaforma di analisi SEO e lead targeting basata su AI.",
  },
  en: {
    brand: "Aurora-ADV",
    tagline: "ADV · Social · Real data · Made in Switzerland",
    heroTitle: "Analyze. Target. Convert.",
    heroTitleA: "Innovative by design.",
    heroTitleB: "One of a kind.",
    heroSubtitle:
      "Analyse your link for free: you'll get a professional Audit & SEO report. Our technicians are available for a free consultation after the report.",
    heroSubtitleLead: "Everything in one single solution.",
    urlPlaceholder: "https://your-landing.com",
    analyzeBtn: "Analyze landing",
    analyzing: "Analyzing...",
    invalidUrl: "Invalid URL",
    scores: "Scores",
    overall: "Overall",
    seo: "SEO",
    speed: "Speed",
    analytics: "Analytics",
    grade: "Grade",
    metaTags: "Meta Tags",
    title: "Title",
    description: "Description",
    canonical: "Canonical",
    viewport: "Viewport",
    robots: "Robots",
    ogTitle: "OG Title",
    checks: "Technical checks",
    passed: "Passed",
    failed: "Failed",
    critical: "Critical",
    warning: "Warning",
    info: "Info",
    aiSuggestions: "AI Suggestions",
    impact: "Impact",
    high: "High",
    medium: "Medium",
    low: "Low",
    trackers: "Installed trackers",
    installed: "installed",
    notFound: "not installed",
    stats: "Page stats",
    words: "Words",
    images: "Images",
    missingAlt: "no alt",
    internalLinks: "Internal links",
    externalLinks: "External links",
    loadTime: "Load time",
    pageSize: "Page size",
    targetingTitle: "Set up targeting",
    targetingSub: "Define the ideal audience for your cross-channel campaign.",
    gender: "Gender",
    all: "All",
    male: "Male",
    female: "Female",
    ageRange: "Age range",
    interests: "Interests",
    interestsPlaceholder: "Add interest and press Enter",
    geography: "Geographic area",
    geoPlaceholder: "e.g. Italy, Northern Europe, USA",
    budget: "Campaign budget",
    launchCampaign: "Launch AI campaign",
    whatsappNumber: "WhatsApp number (lead destination)",
    whatsappNumberHint: "International format, e.g. +39 351 570 7057",
    whatsappMessage: "Pre-filled message",
    whatsappMessageDefault: "Hi, I saw your landing page and I'm interested",
    whatsappCta: "WhatsApp CTA active",
    whatsappCtaDesc: "Leads will tap and this chat opens on their phone.",
    whatsappOpenChat: "Open demo chat",
    whatsappDetected: "WhatsApp button detected on landing",
    whatsappNotFound: "No WhatsApp button on landing",
    campaignRunning: "Campaign live",
    liveDashboard: "Live dashboard",
    impressions: "Impressions",
    clicks: "Clicks",
    conversions: "Conversions",
    ctr: "CTR",
    cpc: "CPC",
    spent: "Spent",
    of: "of",
    channels: "Channels",
    channel: "Channel",
    performance: "Performance over time",
    liveLeads: "Real-time leads",
    matchScore: "Match",
    action: "Action",
    impression: "impression",
    click: "click",
    conversion: "conversion",
    newCampaign: "New analysis",
    exportConversions: "Export conversions",
    exportHint: "Download all converted leads as CSV or Excel",
    budgetOpt: "Real-time budget optimization",
    budgetOptDesc: "AI automatically reallocates budget to best-performing channels.",
    autoOptimizing: "Auto-optimization active",
    fetching: "Fetching page...",
    parsing: "Parsing HTML...",
    scoring: "Scoring metrics...",
    aiRunning: "AI generating suggestions...",
    poweredBy: "AI Powered by Claude",
    footer: "AI-powered SEO analysis and lead targeting platform.",
  },
};

export const LANGS = ["it", "en", "de", "fr", "es", "pt", "ru", "zh", "ja", "ar"];
export const RTL_LANGS = ["ar"];
const EXTRA = { en: enX, de: deX, fr: frX, es: esX, pt: ptX, ru: ruX, zh: zhX, ja: jaX, ar: arX };
let current = "it";
export const setCurrentLang = (l) => { current = l; };
export const getCurrentLang = () => current;

export const t = (lang, key) => translations[lang]?.[key] ?? EXTRA[lang]?.keys[key] ?? translations.en[key] ?? key;
export const translate = (lang, it, en) => {
  if (lang === "it" || it == null) return it;
  if (lang === "en") return en ?? EXTRA.en.strings[it] ?? it;
  return EXTRA[lang]?.strings[it] ?? en ?? EXTRA.en.strings[it] ?? it;
};
export const T = (it, en) => translate(current, it, en);
export const N = (s) => s;
const deep = (it, en, lang) => (typeof it === "string" ? translate(lang, it, typeof en === "string" ? en : undefined)
  : Array.isArray(it) ? it.map((x, i) => deep(x, en?.[i], lang))
  : it && it.constructor === Object && !it.$$typeof ? Object.fromEntries(Object.entries(it).map(([k, v]) => [k, deep(v, en?.[k], lang)])) : it);
export const localized = (obj, lang) => obj[lang] ?? deep(obj.it, obj.en, lang);
